import { useCallback, useEffect, useState } from 'react'
import { getAgencyScans } from '../Services/scansService'

interface Scan {
  id: string
  createdAt: string
  updatedAt?: string
  type: string
  method: string
  subscriber: {
    firstName: string
    lastName: string
  }
  firstresponder: {
    firstName: string
    lastName: string
  }
}

interface PaginatedScansResult {
  data: Scan[]
  total: number
  page: number
  limit: number
  totalPages: number
}

interface AgencyScansQuery {
  page?: number
  limit?: number
  search?: string
  startDate?: string | null
  endDate?: string | null
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
  filtering?: any
}

export const useAgencyScans = (agencyId: string | undefined) => {
  const [scansData, setScansData] = useState<PaginatedScansResult | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetchScans = useCallback(
    async (query: AgencyScansQuery = {}) => {
      if (!agencyId) return

      setLoading(true)
      setError(null)

      try {
        const result = await getAgencyScans(agencyId, query) as PaginatedScansResult
        setScansData(result)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch scans')
        console.error('Error fetching agency scans:', err)
      } finally {
        setLoading(false)
      }
    },
    [agencyId]
  )

  useEffect(() => {
    if (agencyId) {
      refetchScans()
    }
  }, [agencyId, refetchScans])

  return {
    scansData,
    loading,
    error,
    refetchScans
  }
}